import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 20a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1ZM15.793 2.793a3.121 3.121 0 1 1 4.414 4.414L7.644 19.77l-.058.059c-.288.288-.541.542-.847.729a3 3 0 0 1-.867.36C5.524 21 5.165 21 4.758 21H3a1 1 0 0 1-1-1v-1.758c0-.407 0-.765.083-1.114a3 3 0 0 1 .36-.867c.186-.306.44-.56.728-.846l.06-.06L15.792 2.794Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgEdit03.displayName = 'Edit03';
export default SvgEdit03;
